import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SellersService, Seller } from 'src/app/core/sellers.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';

@Component({
  selector: 'app-sellers-edit-dialog',
  templateUrl: './sellers-edit-dialog.component.html',
  styleUrls: ['./sellers-edit-dialog.component.scss'],
})
export class SellersEditDialogComponent {
  seller?: Seller;
  seller_edit_form_group: FormGroup = this.form_service.seller_edit_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_seller_edit_running: boolean = false;

  constructor(
    private form_service: FormService,
    private dialog_ref: MatDialogRef<SellersEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private sellers_service: SellersService,
    private error_service: ErrorService,
  ) {
    this.seller = data.seller;
  }

  ngOnInit(): void {
    this.seller_edit_form_group.get(this.form_service.firstname_label)?.setValue(this.seller?.firstname);
    this.seller_edit_form_group.get(this.form_service.lastname_label)?.setValue(this.seller?.lastname);
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onConfirmClick(): void {
    if (this.isFormValid() && this.seller?.seller_id) {
      this.seller.firstname = this.seller_edit_form_group.get(this.form_service.firstname_label)?.value;
      this.seller.lastname = this.seller_edit_form_group.get(this.form_service.lastname_label)?.value;

      this.edit(this.seller);
    }
  }

  edit(seller: Seller): void {
    this.is_seller_edit_running = true;
    this.sellers_service.edit(seller).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_seller_edit_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_seller_edit_running = false;
      },
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.seller_edit_form_group);
  }
}
